import { Component } from '@angular/core';
import { NavbarComponent } from '../../shared/components/navbar/navbar.component';
import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';
import { FullImageComponent } from '../../shared/components/full-image/full-image.component';


@Component({
  selector: 'app-main',
  imports: [NavbarComponent, SidebarComponent, RouterOutlet, FullImageComponent],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {

}
